import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import { PLATFORM_CODE } from '../../fields';
import { PLATFORM_VIDEO_REPORT_ID } from './platformVideoReportId';

const platformReportFooterColumnDefinition = [PLATFORM_CODE].map(createFooterMapper(PLATFORM_VIDEO_REPORT_ID));

export default platformReportFooterColumnDefinition;
